import * as React from 'react';
import clsx from 'clsx';
import { Interactive } from '../Base/Interactive/Interactive';
import Spinner from '../Spinner';
import Svg from '../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "grouped": "Button-grouped_3peUD"
};
const Button = /*#__PURE__*/React.forwardRef(Button_withRef);
function Button_withRef({
  kind,
  intent,
  small,
  block,
  active,
  loading,
  iconOnly,
  iconBefore,
  iconAfter,
  grouped,
  shape,
  className,
  children,
  ...extraProps
}, ref) {
  const rootClasses = clsx('Button', {
    [styles.grouped]: grouped,
    [`Button--outline`]: kind === 'outline',
    [`Button--ghost`]: kind === 'ghost',
    [`Button--link`]: kind === 'link',
    [`Button--secondary`]: kind === 'secondary',
    [`Button--brand`]: intent === 'brand',
    [`Button--positive`]: intent === 'success',
    [`Button--negative`]: intent === 'danger',
    [`Button--small`]: small,
    [`Button--block`]: block,
    [`Button--iconOnly`]: iconOnly,
    [`Button--active`]: active,
    [`Button--loading`]: loading
  }, className);
  return /*#__PURE__*/_jsxs(Interactive, {
    ref: ref,
    disabled: loading,
    className: rootClasses,
    ...extraProps,
    children: [iconBefore && /*#__PURE__*/_jsx(Svg, {
      name: iconBefore,
      focusable: "false",
      fill: "currentColor",
      className: "Button-icon"
    }), React.Children.map(children, child => typeof child === 'string' ? /*#__PURE__*/_jsx("span", {
      className: clsx('Button-label', {
        'sr-only': iconOnly
      }),
      children: child
    }) : child), iconAfter && /*#__PURE__*/_jsx(Svg, {
      name: iconAfter,
      focusable: "false",
      fill: "currentColor",
      className: "Button-icon"
    }), loading ? /*#__PURE__*/_jsx(Spinner, {
      name: "dots",
      style: {
        '--fill': 'currentColor'
      },
      className: "Button-spinner"
    }) : null]
  });
}
Button.displayName = 'Button';
export { Button };